jQuery(document).ready(function($) {
    const swiper = new Swiper('.testimonial-swiper', {
        loop: false,
        spaceBetween: 24,
        slidesPerView: 1,
        grabCursor: true,
        navigation: {
            nextEl: '.testimonial-swiper-wrap .swiper-button-next',
            prevEl: '.testimonial-swiper-wrap .swiper-button-prev',
        },
        pagination: {
            el: '.testimonial-swiper-wrap .swiper-pagination',
            clickable: true,
        },
        observer: true,
        observeParents: true,
    });
});
